import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { Amount } from '@/features/payouts/components/Amount'
import { Emphasize } from '@/features/payouts/components/Emphasize'
import { byDesign } from '@/infra/design'
import imgManageBillingUrl from '@/assets/misc/img_manage-billing.svg'
import MakeDepositIllustration from '@/components/SpotIllustration/MakeDepositIllustration'

export interface ConfirmPayoutModalProps {
  showing: boolean
  onClose: () => unknown
  onConfirm: () => unknown
  total: number
  transactionCount: number
}

export function ConfirmPayoutModal({
  showing,
  onClose,
  onConfirm,
  total,
  transactionCount,
}: ConfirmPayoutModalProps) {
  return (
    <ModalSheet showing={showing} onRequestClose={onClose}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgManageBillingUrl}
            illustration={byDesign(undefined, MakeDepositIllustration)}
          />
          <ModalSheetContentTitle>
            Are you sure you want to issue the payout?
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            You are about to issue a{' '}
            <Emphasize bold>
              <Amount value={total} />
            </Emphasize>{' '}
            payout consisting of{' '}
            <Emphasize bold>{transactionCount} transactions</Emphasize>. Please
            double check your approved transactions before proceeding.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Cancel" onPress={onClose} />
          <Button label="Issue Payout" variant="primary" onPress={onConfirm} />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
